import {
	ClientCacheManager,
	FormsActionTypes,
	FormsEntities,
	MessageBox,
	Mobile,
	ProjectHelper,
	SDKVersion
} from '@bimser/common';
import {
	BCContent,
	BCDeviceViewer,
	BCLayout,
	BCLoading,
	BCNotification,
	BCThemeChanger,
	findMessage,
	ISize,
	loadDayJsLocale
} from '@bimser/components';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { IRuleType, RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import {
	FormItemTypes,
	IDictionary,
	RxEventEmitter,
	createGuid,
	isNullOrUndefined,
	loadDependency,
	removeDependency
} from '@bimser/core';
import classNames from 'classnames/bind';
import { Map } from 'immutable';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import * as React from 'react';
import * as reactDomClient from 'react-dom/client';
import * as jsxRuntime from 'react/jsx-runtime';
import { of } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { EventArgs, FormViewer, Repeater } from '../..';
import * as FormControls from '../../../../';
import { IExecuteActionArgs } from '../../../../entities';
import { IUserEvent } from '../../../../entities/services';
import { getTriggeredRules, mergeDataAndView } from '../../../../helper';
import { IChildFormReturnEventArgs, IMessageReceivedEventArgs } from '../../entities/EventArgs';
import Form from '../Form';
import { IFormProperties } from '../Form/entities';
import Styles from './assets/styles.scss';
import { IFormViewer } from './entities';

const cx = classNames.bind(Styles);
const executionFormContainer = { height: '100%' };
const layoutStyles = { height: '100%' };

export default class FormView extends React.PureComponent<IFormViewer, {}> {
	SDKVersion: SDKVersion = '2';
	form: Form;
	containerElem: HTMLDivElement;
	reload: boolean;
	viewers: any[];
	repeaters: any[];
	_isMounted = false;
	_viewControllerMobile: string;
	_incomingActiveView: string = null;

	removeExternalLibraries: () => void;

	constructor(props: IFormViewer) {
		super(props);
		this.initializeForm = this.initializeForm.bind(this);
		this.loadFormClass = this.loadFormClass.bind(this);

		this.initializeRxEvents = this.initializeRxEvents.bind(this);
		this.onInternalEvent = this.onInternalEvent.bind(this);
		this.onExternalEvent = this.onExternalEvent.bind(this);
		this.subscribeEvents = this.subscribeEvents.bind(this);
		this.executionMode = this.executionMode.bind(this);
		this.previewMode = this.previewMode.bind(this);
		this.onDeviceViewerDimensionChanged = this.onDeviceViewerDimensionChanged.bind(this);
		this.onDeviceViewerClose = this.onDeviceViewerClose.bind(this);
		this.onDeviceViewerAfterOpen = this.onDeviceViewerAfterOpen.bind(this);
		this.forceToUpdate = this.forceToUpdate.bind(this);
		this.initizeFormViewers = this.initizeFormViewers.bind(this);
		this.initiliazeRepeaters = this.initiliazeRepeaters.bind(this);
		this.setFormViewerControls = this.setFormViewerControls.bind(this);
		this.subscribeFormEvents = this.subscribeFormEvents.bind(this);
		this.setExternalLibraries = this.setExternalLibraries.bind(this);

		ProjectHelper.initGlobalProjectsObject({
			projectReferenceCounts: {},
			projects: {},
			instances: {}
		});
	}

	setExternalLibraries() {
		// Bu function dinamik olarak yüklenen form projesinin index.js dosyasındaki eksik dosyaları tanımlamak amaçlı yazılmıştır. dinamik olarak yüklenen form projesinin index.js dosyasındaki eksik dosyaları tanımlamak amaçlı yazılmıştır.
		const prefix = `SynergyProjects_SDK_${this.SDKVersion}_libraries_`;
		const libraries = {
			'@bimser/form-controls/dist/environments/runtime': FormControls.Runtime,
			'@bimser/form-controls': FormControls,
			'react/jsx-runtime': jsxRuntime,
			'react-dom/client': reactDomClient
		};

		for (const key in libraries) {
			if (Object.prototype.hasOwnProperty.call(libraries, key)) {
				window[`${prefix}${key}`] = libraries[key];
			}
		}

		return () => {
			for (const key in libraries) {
				if (Object.prototype.hasOwnProperty.call(libraries, key)) {
					delete window[`${prefix}${key}`];
				}
			}
		};
	}

	componentDidUpdate() {
		const { lastBatchGuid, endTransactionGuid } = this.props;

		if (lastBatchGuid) {
			if (lastBatchGuid.startsWith('RunEvent_')) {
				this.form.emit('system:FormItemsLoaded', { guid: this.props.lastBatchGuid });
			} else if (this.props.dispatchAction) {
				this.props.dispatchAction({
					type: FormsActionTypes.LAST_BATCH_GUID_RESOLVED,
					payload: this.props.lastBatchGuid
				});
			}
		}

		if (endTransactionGuid) {
			this.form?.emit('system:transactionEnd', endTransactionGuid);
		}
	}

	componentDidMount() {
		this._isMounted = true;
		if (this.props.mode === 'execution') {
			const storedFormInstance: Form = ProjectHelper.getProjectInstance(this.props.windowId);

			if (this.props.shadow && this.props.currentLanguage?.twoLetterCulture) {
				loadDayJsLocale(this.props.currentLanguage.twoLetterCulture);
			}

			if (
				this.props.formViewerProps?.formViewerControlType ===
				FormItemTypes.EControlTypes.Repeater
			) {
				this.loadFormClass(classInstance => {
					this.form = classInstance;
					this.initializeForm(this.props);
					this.props.setForm?.(this.form);
				});
			} else if (storedFormInstance) {
				this.reload = true;
				this.form = storedFormInstance;
				this.initializeForm(this.props);
				this.updateFormInstance();
				this.props.setForm?.(this.form);
			} else {
				this.loadFormClass(classInstance => {
					this.form = classInstance;
					this.initializeForm(this.props);
					this.props.setForm?.(this.form);
				});
			}
		} else if (this.props.mode === 'preview') {
			this.form = new Form();
			this.initializeForm(this.props);
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps: IFormViewer) {
		const storedFormInstance: Form = ProjectHelper.getProjectInstance(this.props.windowId);
		const storedFormInstanceUpdated =
			storedFormInstance &&
			nextProps.data &&
			!nextProps.data.equals(storedFormInstance.items);
		const dataUpdated = nextProps.data && !nextProps.data.equals(this.props.data);
		const viewUpdated = nextProps.view && !nextProps.view.equals(this.props.view);

		const serverPrintDataItemsUpdated =
			(nextProps.serverPrintDataItems &&
				!nextProps.serverPrintDataItems.equals(this.props.serverPrintDataItems)) ||
			(this.props.serverPrintDataItems &&
				this.props.serverPrintDataItems.equals(nextProps.serverPrintDataItems));
		const serverPrintStructureItemsUpdated =
			(nextProps.serverPrintStructureItems &&
				!nextProps.serverPrintStructureItems.equals(
					this.props.serverPrintStructureItems
				)) ||
			(this.props.serverPrintStructureItems &&
				this.props.serverPrintStructureItems.equals(nextProps.serverPrintStructureItems));

		const windowSizeUpdated =
			nextProps.windowSize && !_isEqual(nextProps.windowSize, this.props.windowSize);
		const summaryMessagesUpdated =
			nextProps.summaryMessages &&
			!nextProps.summaryMessages.equals(this.props.summaryMessages);
		const displayModeUpdated = this.props.mode !== nextProps.mode;
		const documentIdUpdated = this.props.documentId !== nextProps.documentId;
		const activeViewChanged = this.props.activeView !== nextProps.activeView;
		const formViewersChanged =
			JSON.stringify(this.props.formViewers?.toJS() || {}) !==
			JSON.stringify(nextProps.formViewers?.toJS() || {});
		const repeatersChanged =
			JSON.stringify(this.props.formRepeaters?.toJS() || {}) !==
			JSON.stringify(nextProps.formRepeaters?.toJS() || {});

		if (documentIdUpdated) {
			this.form.documentId = nextProps.documentId;
		}

		if (
			dataUpdated ||
			storedFormInstanceUpdated ||
			viewUpdated ||
			windowSizeUpdated ||
			displayModeUpdated ||
			activeViewChanged ||
			formViewersChanged ||
			repeatersChanged ||
			serverPrintDataItemsUpdated ||
			serverPrintStructureItemsUpdated ||
			(this.form?.__formViewerControlType && !this.form?.__isInitialized)
		) {
			const formItem = nextProps.data?.get('Form');
			const formProperties = formItem?.properties || {};

			const properties: IFormProperties = {
				items: nextProps.data || this.form?.items,
				view: nextProps.view || this.form?.view,
				windowSize: nextProps.windowSize,
				activeView: nextProps.activeView || this.form?.activeView,
				...formProperties
			} as any;

			if (this.form) {
				if (nextProps.serverPrintDataItems?.size) {
					this.initializeServerPrintForm(nextProps);
				} else {
					this.form.__getServerPrintFormProperties = undefined;
				}

				this.form.__loadProperties(properties);
				this.form.__createControls();

				if (nextProps.formViewers?.size) {
					this.initizeFormViewers(nextProps);
				}

				if (nextProps.formRepeaters?.size) {
					this.initiliazeRepeaters(nextProps);
				}
			}
		}

		if (summaryMessagesUpdated) {
			this.form.summaryMessages = nextProps.summaryMessages;
		}

		if (!this._incomingActiveView) {
			const validActiveViewChange = this.props.activeView && nextProps.activeView;
			this._incomingActiveView =
				validActiveViewChange && this.props.activeView != nextProps.activeView
					? nextProps.activeView
					: null;
		}

		if (
			this._incomingActiveView &&
			this.form.view?.entities.items.count() &&
			this.form.items?.count()
		) {
			this._incomingActiveView = null;
			const mergeData = mergeDataAndView(this.form.items, this.form.view).toJS();
			Mobile.MobileView.setFormStructure({
				form: { data: mergeData },
				formPanelId: this.props?.windowId || ''
			});
		}

		if (!this.props.eventEmitter && nextProps.eventEmitter) {
			this.subscribeFormEvents(nextProps);
		}

		this.updateFormInstance();
	}

	loadFormClass(callback: (classInstance: Form) => void) {
		//Pre-Define return fetched Form Class function.
		const projectExist = ProjectHelper.getProject(this.props.projectName);
		if (!projectExist) {
			const listenLoadProjectFn = (module: {
				forms: (formName: string) => { default: typeof Form };
			}) => {
				const formInstance = module?.forms?.(this.props.formName);

				if (formInstance) {
					ProjectHelper.setProject(this.props.projectName, module);
					const formIns = new formInstance.default();
					ProjectHelper.setProjectInstance(this.props.windowId, formIns);

					callback(formIns);
				} else {
					BCNotification.error({ message: findMessage.get('103709') });
					console.log(
						'Module is not correct format.',
						this.props.projectName,
						this.props.formName,
						module
					);
				}
			};

			this.removeExternalLibraries = this.setExternalLibraries();

			ProjectHelper.RunPromiseFormService({
				projectName: this.props.projectName,
				formName: this.props.formName,
				serviceName: 'Ping',
				serviceMethod: 'get',
				projectVersion: this.props.packageVersion
			})
				.then(() => {
					const dynamicImportUrl = this.props.clientUrl.replace(
						'/api',
						'/dist/index.js?version=' + createGuid()
					);

					loadDependency(
						dynamicImportUrl,
						`${this.props.projectName}_${this.props.formName}`,
						() => {
							listenLoadProjectFn(
								window[`${this.props.projectName}_SDK_${this.SDKVersion}`]
							);
						}
					);
				})
				.catch(error => {
					BCNotification.error({ message: findMessage.get('103709') });
					console.log('Project Dist could not be loaded');
				});
		} else {
			const project = ProjectHelper.getProject(this.props.projectName);
			const formClass = project.forms?.(this.props.formName);

			if (formClass) {
				ProjectHelper.increaseProjectReference(this.props.projectName);
				const formIns = new formClass.default();
				ProjectHelper.setProjectInstance(this.props.windowId, formIns);

				callback(formIns);
			} else {
				console.log(
					'Form cannot found in project',
					this.props.projectName,
					this.props.formName
				);
			}
		}
	}

	componentWillUnmount() {
		this._isMounted = false;

		document
			.querySelectorAll(`style[form-relation-id="${this.props.windowId}"]`)
			.forEach(style => style.remove());

		if (this.props.parentFormId && this.form) {
			this.form.emitEventToParent({
				type: 'CHILD_FORM_CLOSED',
				data: { windowId: this.form.getPanelId() }
			});
		}

		if (this.form && !this.form.childForms.length) {
			if (this.form.rxExternalSubscription) {
				this.form.rxExternalSubscription.unsubscribe();
			}

			if (this.form.rxInternalSubscription) {
				this.form.rxInternalSubscription.unsubscribe();
			}
		}

		const removeEventList = [
			'system:ExecuteAction',
			'dispatchAction',
			'event:OnFormSave',
			'event:OnFormSaveAs'
		];

		removeEventList.forEach(e => {
			if (this.form) {
				this.form.off(e);
			}
		});

		this.form?.__openedModalList?.forEach(modalId => {
			MessageBox.closeModal(modalId);
		});

		this.props?.eventEmitter?.clearEvents();

		this.updateFormInstance();

		RxEventEmitter.subjects['$checkRules_' + this.props.windowId]?.unsubscribe();
		Object.keys(RxEventEmitter.uncaughtSubjects).forEach(key => {
			if (key.includes(this.props.windowId)) {
				delete RxEventEmitter.uncaughtSubjects[key];
			}
		});

		Mobile.MobileView.synergyFormOnClose(this.props.windowId);
	}

	onInternalEvent(data: EventArgs.IMessageReceivedEventArgs) {
		this.form.emit('event:OnMessageReceived', data);
	}

	onExternalEvent(data: EventArgs.IMessageReceivedEventArgs) {
		this.form.emit('event:OnMessageReceived', data).then(r => {
			if (data.type == 'CHILD_FORM_CLOSED') {
				if (this.props.fromMobile) {
					this.props.sendToolbarItemsToMobile?.(true);
				}

				this.form.childForms = this.form.childForms.filter(
					c => c.windowId != data.data.windowId
				);
				if (this.form.childForms.length) {
					this.subscribeForeignEvents(true, data.data.windowId);
				}
			}

			if (data.type === 'RETURN_CHILD_FORM_DATA') {
				this.form.emit('event:OnChildFormReturn', data.data);
				this.form.emit<IUserEvent<IChildFormReturnEventArgs>>(
					'event:server:OnChildFormReturn',
					{
						argument: {
							extraProps: {
								serverArgs: data.data.extraProps.serverArgs,
								clientArgs: data.data.extraProps.clientArgs
							}
						},
						controlId: this.form.name,
						name: 'OnChildFormReturn',
						sender: 'web',
						guid: createGuid()
					}
				);
			}

			if (data.type === FormsActionTypes.RELATED_ITEM_DATA_CHANGE) {
				const args: FormsEntities.RelatedDataChangeAction = data.data;

				const control = this.form.controls.find(
					({ name }) => name === args.relatedControlId
				);
				if (control?.controlType === FormItemTypes.EControlTypes.ContextMenu) {
					return;
				}

				let userEventData: IUserEvent<any>;

				switch (args.executeActionType) {
					case 'CreateFormArgs': {
						userEventData = {
							argument: {
								row: { RELATIONDOCUMENTID: args.documentId },
								rows: [],
								cancel: false
							},
							controlId: args.relatedControlId,
							name: 'OnRowInserting',
							sender: 'web',
							guid: createGuid(),
							runImmediately: true
						};
						break;
					}
					case 'OpenFormArgs': {
						userEventData = {
							argument: {
								newRow: { RELATIONDOCUMENTID: args.documentId },
								cancel: false,
								rows: [],
								oldRow: { RELATIONDOCUMENTID: args.documentId }
							},
							controlId: args.relatedControlId,
							name: 'OnRowUpdating',
							sender: 'web',
							guid: createGuid(),
							runImmediately: true
						};
						break;
					}
				}

				this.form.__runServerEvent(userEventData).then(arg => {
					this.form.__executedServerEvent = arg.executedServerEvent;

					const rows = _get(
						arg,
						[
							'loadActionData',
							'items',
							'entities',
							'items',
							args.relatedControlId,
							'properties',
							'rows'
						],
						[]
					);

					const row = rows.find(
						r => _get(r, ['data', 'RELATIONDOCUMENTID']) === args.documentId
					);

					if (row) {
						switch (args.executeActionType) {
							case 'CreateFormArgs': {
								this.form[args.relatedControlId].__emitRelationEvents(
									row,
									'create'
								);
								break;
							}
							case 'OpenFormArgs': {
								this.form[args.relatedControlId].__emitRelationEvents(
									row,
									'update'
								);
								break;
							}
						}
					}

					if (arg.loadActionData.isDMFileSecretModified) {
						this.form.__loadDocumentViewer();
					}

					if (arg.loadActionData.isRDFileSecretModified) {
						this.form.isLoadingRDObjects = false;
						this.form.__getRDObjects();
					}
				});
			}
		});
	}

	initializeRxEvents() {
		this.createRxSubscription(
			this.form.getInternalEventName(),
			this.onInternalEvent,
			'rxInternalSubscription'
		);
		this.createRxSubscription(
			this.form.getExternalEventName(),
			this.onExternalEvent,
			'rxExternalSubscription'
		);
		this.createRxSubscription(
			'FORM.ON_FORM_CLOSE',
			() => {
				ClientCacheManager.cleanCache(this.props.windowId);
			},
			'rxExternalSubscription'
		);

		const formCloseEmitterId = 'FORM.ON_FORM_CLOSE_' + this.props.windowId;
		if (!RxEventEmitter.subjects[`$${formCloseEmitterId}`]) {
			RxEventEmitter.listen(formCloseEmitterId, {
				next: () => {
					ClientCacheManager.cleanCache(this.props.windowId);
					RxEventEmitter.subjects[`$${formCloseEmitterId}`]?.unsubscribe();
					delete RxEventEmitter.subjects[`$${formCloseEmitterId}`];
					ProjectHelper.removeProjectInstance(this.props.windowId);

					ProjectHelper.removeProject(this.props.projectName);

					const projectStillAlive = ProjectHelper.getProject(this.props.projectName);

					if (!projectStillAlive) {
						removeDependency(`${this.props.projectName}_${this.props.formName}`);
					}

					this.removeExternalLibraries?.();
				}
			});
		}
	}

	createRxSubscription(
		eventName: string,
		eventHandler: (data: IMessageReceivedEventArgs) => void,
		subscriptionProperty: string
	) {
		if (this.form[subscriptionProperty]) {
			this.form[subscriptionProperty].unsubscribe();
		}

		RxEventEmitter.listen(eventName, {
			next: eventHandler
		}).then(subscription => {
			const observableSubscription = of(subscription).pipe(distinctUntilChanged());
			observableSubscription.subscribe(value => {
				this.form[subscriptionProperty] = value;
			});
		});
	}

	forceToUpdate(forceId: string) {
		if (!this.form.__forceRender.find(id => id === forceId)) {
			this.form.__forceRender = [...this.form.__forceRender, forceId];
			this.forceUpdate(() => {
				this.form.__forceRender = this.form.__forceRender.filter(id => id !== forceId);
			});
		}
	}

	initializeForm(props: IFormViewer) {
		if (!this.form) {
			return;
		}

		this.form.__shadowDomMode = this.props.shadow;
		this.form.__interactionHelper = this.props.interactionHelper;
		this.form.__windowId = props.windowId;
		this.form.__parentFormId = props.parentFormId;
		this.form.serviceUrl = props.clientUrl;
		this.form.fetch.BaseUrl = props.clientUrl;
		this.form.formName = props.formName;
		this.form.projectName = props.projectName;
		this.form.packageVersion = props.packageVersion;
		this.form.windowSize = props.windowSize;
		this.form.isFirstLoad = !this.reload;
		this.form.documentId = props.documentId;
		this.form.currentLanguage = props.currentLanguage;
		this.form.supportedLanguages = props.supportedLanguages;
		this.form.displayMode = props.mode;
		this.form.parentWindowType = props.parentWindowType || 'preview';
		this.form.openOn = props.openOn || 'panel';
		this.form.summaryMessages = props.summaryMessages;
		this.form.activeView = props.activeView;
		this.form.createSecretKey = props.createSecretKey;
		this.form.relatedControlId = props.relatedControlId;
		this.form.executeActionType = props.executeActionType;
		this.form.isDataEntryForm = props.isDataEntryForm;
		this.form.__validateModalForm = props.validate;
		this.form.__mobileFormView = props.mobileFormView;
		this.form.__fromMobile = props.fromMobile;
		this.form.__isFlowEventForm = props.isFlowEventForm;
		this.form.flowSecretKey = props.flowSecretKey;
		this.form.draftSecretKey = props.createSecretKey;
		this.form.runSecretKey = props.runSecretKey;
		this.form.__closeWindowById = props.closeWindowById;
		this.form.__forceUpdate = this.forceToUpdate;
		this.form.__getFormViewerData = props.getFormViewerData;
		this.form.__hasScrollbar = props.hasScrollbar;
		this.form.__setFormViewerControls = () => {
			this.setFormViewerControls(this.props.data);
		};
		this.form.__closeFormById = props.closeFormById;
		this.form.fastApprove = props.fastApprove;

		if (props.formViewerProps) {
			this.form.__formViewerControlType = props.formViewerProps.formViewerControlType;
			this.form.__formViewerControlName = props.formViewerProps.formViewerControlName;
			this.form.__formViewerFormId = props.formViewerProps.formViewerFormId;
			this.form.__formViewerViewName = props.formViewerProps.formViewerViewName;
		}

		this.initializeRxEvents();

		if (props.formViewerProps?.formViewerControlType) {
			this.form.subscribe('system:PropertyChanged', props.changeProperty);
		}

		if (!isNullOrUndefined(props.canSaveAsDraft)) {
			this.form.canSaveAsDraft = props.canSaveAsDraft;
		}
		if (props.formCaptionTextChanged && !props.formViewerProps?.formViewerControlType) {
			this.form.__formCaptionTextChanged = props.formCaptionTextChanged;
		}

		if (props.showLoading) {
			this.form.__showLoading = props.showLoading;
		}

		if (props.hideLoading) {
			this.form.__hideLoading = props.hideLoading;
		}

		this.form.subscribe('system:OnBeforeSaveAsDraft', () => {
			this.props.onLoadingChanged?.(true);
		});

		this.form.subscribe('system:OnAfterSaveAsDraft', (result: boolean) => {
			this.props.onLoadingChanged?.(false);
		});

		this.form.subscribe('system:ExecuteAction', (args: IExecuteActionArgs<any>) => {
			if (!this.props.onExecuteAction) {
				return;
			}

			/**
			 * ON_BEFORE_EXECUTE_ACTION
			 */
			const OnBeforeExecuteActionArgs: EventArgs.IBeforeExecuteActionArgs = {
				data: args,
				cancel: false
			};
			this.form.emit('event:OnBeforeExecuteAction', OnBeforeExecuteActionArgs).then(res => {
				if (!OnBeforeExecuteActionArgs.cancel) {
					const openResponse = new Promise(resolve => {
						args.openResponse = resolve;
						this.props.onExecuteAction(args);
					});
					openResponse.then((childFormId: string) => {
						this.form.childForms.push({
							sender: 'ExecuteAction',
							windowId: childFormId,
							data: null
						});
						this.form.emit('event:OnExecuteAction', {
							data: OnBeforeExecuteActionArgs?.data
						});
					});
				}
			});
		});

		this.subscribeEvents(props);
		this.updateFormInstance();
		this.subscribeForeignEvents(true);

		if (
			this.form.__fromMobile &&
			this.form.__mobileFormView === Mobile.MobileFormView.NativePlus
		) {
			window.alert = function () {};
		}

		this.form.__loadStyles(this.props.formName).forEach(styleTag => {
			styleTag.setAttribute('form-relation-id', this.props.windowId);

			const shadowRoot = this.form.__getShadowRoot();

			if (shadowRoot) {
				shadowRoot.insertBefore(styleTag, shadowRoot.querySelector('body'));
			} else {
				document.head.appendChild(styleTag);
			}
		});
	}

	executionMode(props: IFormViewer) {
		/**
		 * Redux asenkron yapısından dolayı kaynaklanabilecek bir durumdan dolayı
		 * this.props.onLoadingChanged çalıştıktan sonra this.form.isFirstLoad öncesinde
		 * true olmasına rağmen false a dönüyor. bu sebeple form create isteği atmıyor.
		 * create isteğini kontrol ettiği yerden önce yukarıda atanan değer tekrar atanıyor.
		 */

		this.form.isFirstLoad = !this.reload;

		if (!this.form.__formViewerControlType && !props.mediaScreen) {
			this.form
				.__getItems()
				.then(args => {
					const { items, response, dataItems, structureItems } = args;

					this.setFormViewerControls(dataItems);

					Mobile.MobileView.setFormStructure({
						...response,
						formPanelId: this.props?.windowId || '',
						version: items.entities.items
							.get(this.form.formName, null)
							?.properties.get('version', null)
					});

					if (props.formItemsLoaded) {
						this.form.__formItemsLoaded = props.formItemsLoaded;
						const data = items.toJS();

						const formRules: IDictionary<RuleEngineEntities.IRule> = dataItems
							.find(i => i.type === FormItemTypes.EContainerTypes.Form)
							.properties.get('rules');
						const rules = getTriggeredRules(formRules, {
							controlId: this.form.name,
							eventName: 'OnLoad'
						}).toJS() as IDictionary<IRuleType>;

						props.formItemsLoaded({
							formId: props.windowId,
							documentId:
								props.documentId && props.documentId > 0
									? props.documentId
									: response.documentId,
							items: data,
							dataItems:
								dataItems.toJS() as IDictionary<LayoutCreatorEntities.ILayoutDataItem>,
							structureItems: structureItems.toJS(),
							isFirstLoad: true,
							rules
						});

						this.props.hideLoading?.();
						this.props.onFormLoaded?.();

						if (props.fastApproveMode) {
							this.props.dispatchAction({
								type: FormsActionTypes.FORM_CREATE_COMPLETED,
								payload: { windowId: this.props.windowId }
							});
						}
					}

					if (props.formPropertyChanged) {
						this.form.subscribe('system:PropertyChanged', props.formPropertyChanged);
					}
				})
				.catch(e => {
					if (e) {
						this.form.emit('event:OnError', e);
						if (this.props.onError) {
							this.props.onError(e);
						}
					}

					if (this.props.hideLoading) {
						this.props.hideLoading();
					}
					if (props.fastApproveMode) {
						this.props.dispatchAction({
							type: FormsActionTypes.FORM_CREATE_COMPLETED,
							payload: { windowId: this.props.windowId }
						});
					}
				});
		} else {
			this.form.emit('event:OnDataLoad', {});
			if (props.formItemsLoaded) {
				this.form.__formItemsLoaded = props.formItemsLoaded;
			}
		}

		this.form.items = props.data || this.form.items;
		this.form.view = props.view || this.form.view;
		this.form.__createControls();

		this.props.formReadyForPrint?.();
	}

	setFormViewerControls(items: Map<string, LayoutCreatorEntities.LayoutDataItem>) {
		const viewers = [];
		const repeaterViewers = [];

		items.valueSeq().forEach(item => {
			const commonProps = {
				projectName: item.getIn(['properties', 'projectName']),
				formName: item.getIn(['properties', 'formName']),
				viewName: item.getIn(['properties', 'viewName']),
				formId: this.form.__windowId.split('_')[0],
				controlId: item.id
			};

			if (
				item.type === FormItemTypes.EControlTypes.FormViewer &&
				commonProps.projectName &&
				commonProps.formName
			) {
				viewers.push({
					...commonProps,
					documentIds: item.getIn(['properties', 'documentId'])
						? [item.getIn(['properties', 'documentId'])]
						: [],
					controlType: FormItemTypes.EControlTypes.FormViewer
				});
			} else if (item.type === FormItemTypes.EControlTypes.Repeater) {
				repeaterViewers.push({
					...commonProps,
					documentIds: item.getIn(['properties', 'documentIds']),
					controlType: FormItemTypes.EControlTypes.Repeater
				});
			}
		});

		if (viewers?.length) {
			this.viewers = viewers;
		}

		if (repeaterViewers?.length) {
			this.repeaters = repeaterViewers;
		}

		this.props.getFormViewerData?.({
			serviceUrl: this.form.serviceUrl,
			viewers: [...viewers]
		});
	}

	initizeFormViewers(props: IFormViewer) {
		props.formViewers?.keySeq().forEach(viewerId => {
			const {
				structureItems,
				dataItems,
				clientUrl,
				endTransactionGuid,
				runSecretKey,
				lastBatchGuid
			} = props.formViewers.get(viewerId);
			const viewer = this.viewers.find(_viewer => _viewer.controlId === viewerId);

			const getFormViewProps = (): IFormViewer => ({
				key: (props as any).key,
				formPropertyChanged: props.formPropertyChanged,
				formItemsLoaded: props.formItemsLoaded,
				lastBatchGuid: props.lastBatchGuid || lastBatchGuid,
				endTransactionGuid,
				clientUrl,
				data: dataItems,
				view: structureItems,
				runSecretKey,
				projectName: viewer.projectName,
				formName: viewer.formName,
				mode: 'execution',
				windowId: `${viewer.formId}_FormViewer_${viewerId}_${viewer.viewName}`,
				onFormSave: props.onFormSave,
				onError: props.onError,
				currentLanguage: props.currentLanguage,
				supportedLanguages: props.supportedLanguages,
				dispatchAction: props.dispatchAction,
				onExecuteAction: props.onExecuteAction,
				parentWindowType: 'appForm',
				openOn: props.openOn,
				parentFormId: props.parentFormId,
				summaryMessages: props.summaryMessages,
				onSummaryMessageClose: props.onSummaryMessageClose,
				activeView: viewer.viewName,
				createSecretKey: props.createSecretKey,
				checkRules: props.checkRules,
				formCaptionTextChanged: props.formCaptionTextChanged,
				closeWindowById: props.closeWindowById,
				showLoading: props.showLoading,
				hideLoading: props.hideLoading,
				fromMobile: props.fromMobile,
				mobileFormView: props.mobileFormView,
				executeActionType: props.executeActionType,
				canSaveAsDraft: props.canSaveAsDraft,
				flowSecretKey: props.flowSecretKey,
				changeProperty: props.changeProperty,
				windowSize: props.windowSize
			});

			const viewerControl = this.form[viewerId] as FormViewer;
			if (viewerControl) {
				viewerControl.__getFormViewProps = getFormViewProps;
				if (viewerControl.documentData?.controls?.length === 0) {
					viewerControl.__render();
				}
			}
		});
	}

	initiliazeRepeaters(props: IFormViewer) {
		props.formRepeaters?.keySeq()?.forEach(repeaterId => {
			const repeaterForms = props.formRepeaters.get(repeaterId);
			const repeater = this.repeaters.find(_repeater => _repeater.controlId === repeaterId);
			const formViewerProperties: IDictionary<IFormViewer> = {};

			repeaterForms?.keySeq().forEach(repeaterFormId => {
				const repeaterForm = repeaterForms.get(repeaterFormId);
				const repeaterFormIdSplitted = repeaterFormId.split('_');
				const documentId = repeaterFormIdSplitted[repeaterFormIdSplitted.length - 1];

				formViewerProperties[documentId] = {
					...{ key: (props as any).key },
					runSecretKey: repeaterForm.runSecretKey,
					eventEmitter: props.eventEmitter,
					formPropertyChanged: props.formPropertyChanged,
					formItemsLoaded: props.formItemsLoaded,
					documentId: props.documentId,
					lastBatchGuid: props.lastBatchGuid || repeaterForm.lastBatchGuid,
					endTransactionGuid: repeaterForm.endTransactionGuid,
					clientUrl: props.clientUrl,
					data: repeaterForm.dataItems,
					view: repeaterForm.structureItems,
					projectName: repeater.projectName,
					formName: repeater.formName,
					mode: 'execution',
					windowId: `${repeater.formId}_Repeater_${repeaterId}_${repeater.viewName}_${documentId}`,
					onFormSave: props.onFormSave,
					onError: props.onError,
					currentLanguage: props.currentLanguage,
					supportedLanguages: props.supportedLanguages,
					dispatchAction: props.dispatchAction,
					onExecuteAction: props.onExecuteAction,
					parentWindowType: 'appForm',
					openOn: props.openOn,
					parentFormId: props.parentFormId,
					summaryMessages: props.summaryMessages,
					onSummaryMessageClose: props.onSummaryMessageClose,
					activeView: repeater.viewName,
					createSecretKey: props.createSecretKey,
					checkRules: props.checkRules,
					formCaptionTextChanged: props.formCaptionTextChanged,
					closeWindowById: props.closeWindowById,
					showLoading: props.showLoading,
					hideLoading: props.hideLoading,
					fromMobile: props.fromMobile,
					mobileFormView: props.mobileFormView,
					executeActionType: props.executeActionType,
					canSaveAsDraft: props.canSaveAsDraft,
					flowSecretKey: props.flowSecretKey,
					changeProperty: props.changeProperty,
					windowSize: props.windowSize
				};
			});

			const repeaterControl = this.form[repeaterId] as Repeater;
			if (repeaterControl) {
				repeaterControl.__repeaterFormViewerProps = formViewerProperties;
				repeaterControl.__render();
			}
		});
	}

	initializeServerPrintForm(props: IFormViewer) {
		this.form.__getServerPrintFormProperties = () => ({
			...{ key: (props as any).key },
			formPropertyChanged: props.formPropertyChanged,
			formItemsLoaded: props.formItemsLoaded,
			documentId: props.documentId,
			lastBatchGuid: props.lastBatchGuid,
			clientUrl: props.clientUrl,
			data: props.serverPrintDataItems,
			view: props.serverPrintStructureItems,
			projectName: props.projectName,
			formName: props.formName,
			mode: 'execution',
			windowId: `${props.windowId}_ServerPrint`,
			onFormSave: props.onFormSave,
			onError: props.onError,
			currentLanguage: props.currentLanguage,
			supportedLanguages: props.supportedLanguages,
			dispatchAction: props.dispatchAction,
			onExecuteAction: props.onExecuteAction,
			parentWindowType: 'appForm',
			openOn: props.openOn,
			parentFormId: props.parentFormId,
			summaryMessages: props.summaryMessages,
			onSummaryMessageClose: props.onSummaryMessageClose,
			createSecretKey: props.createSecretKey,
			checkRules: props.checkRules,
			formCaptionTextChanged: props.formCaptionTextChanged,
			closeWindowById: props.closeWindowById,
			showLoading: props.showLoading,
			hideLoading: props.hideLoading,
			fromMobile: props.fromMobile,
			mobileFormView: props.mobileFormView,
			executeActionType: props.executeActionType,
			canSaveAsDraft: props.canSaveAsDraft,
			flowSecretKey: props.flowSecretKey,
			changeProperty: props.changeProperty,
			hasScrollbar: true,
			windowSize: props.windowSize
		});
	}

	previewMode(props: IFormViewer) {
		this.form.items = props.data;
		this.form.view = props.view;
		this.form.__createControls();

		if (props.formPropertyChanged) {
			this.form.subscribe('system:PropertyChanged', props.formPropertyChanged);
		}
	}

	subscribeEvents(props: IFormViewer) {
		this.form.subscribe('dispatchAction', (action: any) => {
			if (this.props.dispatchAction) {
				this.props.dispatchAction(action);
			}
		});

		if (props.checkRules) {
			this.form.subscribe('checkRules', props.checkRules);
		}

		this.form.subscribe('event:OnFormSave', (data: FormsEntities.FormSavePayload) => {
			if (this.props.onFormSave) {
				this.props.onFormSave(data);
			}
		});

		this.form.subscribe('event:OnFormSaveAs', (data: FormsEntities.FormSaveAsPayload) => {
			if (this.props.onFormSaveAs) {
				this.props.onFormSaveAs(data);
			}
		});

		if (props.onSummaryMessageClose) {
			this.form.subscribe('system:onSummaryMessageClose', props.onSummaryMessageClose);
		}

		this.form.emit('event:OnPreInit', { domRef: this.containerElem }).then(async () => {
			if (this.props.mode === 'execution') {
				if (
					this.props.showLoading &&
					!this.form.__formViewerControlType &&
					!this.props.formReadyForPrint
				) {
					await this.props.showLoading();
				}
				this.executionMode(props);
			} else if (this.props.mode === 'preview') {
				this.previewMode(props);
			}

			this.setState({
				formClassLoaded: true
			});
		});

		this.subscribeFormEvents(this.props);
	}

	subscribeFormEvents(props: IFormViewer) {
		if (props.eventEmitter) {
			props.eventEmitter.subscribe('system:OnToolbarButtonClicked', (item: any) => {
				this.form.emit('system:OnToolbarButtonClicked', item);
			});
			props.eventEmitter.subscribe('dm:DMFileUploaded', (data: any) => {
				this.form.emit('event:DMFileUploaded', data);
			});
			props.eventEmitter.subscribe('dm:DMFileUploading', (data: any) => {
				this.form.emit('event:DMFileUploading', data);
			});
			props.eventEmitter.subscribe('system:OnEventButtonClicked', (event: any) => {
				this.form.emit('system:OnEventButtonClicked', event);
			});
			props.eventEmitter.subscribe('system:OnAfterSaveAndContinue', (data: any) => {
				this.form.emit('system:OnAfterSaveAndContinue', data);
			});
			props.eventEmitter.subscribe('system:OnEventActionEvent', (data: any) => {
				this.form.emit('system:OnEventActionEvent', data);
			});
		}
	}

	subscribeForeignEvents(initilizing?: boolean, mobileWindowId?: string) {
		Mobile.MobileView.setFunctionForMobile(
			Mobile.MobileFunctions.TriggerEvent,
			(controlName: string, eventName: string, args?: any) => {
				if ((this.form as any)[controlName]?.emit) {
					(this.form as any)[controlName].emit(eventName, args);
				}
			}
		);

		const isControl = !!mobileWindowId ? !_isEqual(this.form.__windowId, mobileWindowId) : true;
		if (initilizing && isControl) {
			Mobile.MobileView.modalFormOpening({
				formName: this.form.formName,
				projectName: this.form.projectName,
				controlType: this.form.controlType,
				executeActionType: this.form.executeActionType,
				parentWindowType: this.form.parentWindowType,
				formPanelId: this.form.__windowId,
				isChildForm: !!(this.form.executeActionType || this.props.isFlowEventForm)
			});
			const mergeData = mergeDataAndView(this.form.items, this.form.view).toJS();
			if (this.form.view?.entities.items.count() && this.form.items?.count()) {
				Mobile.MobileView.setFormStructure({
					form: { data: mergeData },
					formPanelId: this.props?.windowId || ''
				});
				Mobile.MobileView.setActiveForm({ formPanelId: this.props?.windowId });
			}
			Mobile.MobileView.setFunctionForMobile(
				Mobile.MobileFunctions.CloseFormMobile,
				(value?: string) => this.props.closeWindowById(value)
			);
		}
	}

	updateFormInstance() {
		ProjectHelper.setProjectInstance(this.props.windowId, this.form);
	}

	onDeviceViewerDimensionChanged(dimension: ISize) {
		this.props.onWindowSizeChanged?.(
			LayoutCreatorEntities.WindowSizeFactory({
				width: dimension.width,
				height: dimension.height
			})
		);
	}

	onDeviceViewerClose() {
		this.props.changeDisplayMode?.('design');
	}

	onDeviceViewerAfterOpen() {
		this.props.onWindowSizeChanged?.(
			LayoutCreatorEntities.WindowSizeFactory({
				width: 1024,
				height: 768
			})
		);
	}

	renderPreview() {
		return (
			<BCDeviceViewer
				width={this.props.windowSize?.width || 1024}
				height={this.props.windowSize?.height || 630}
				onDimensionChanged={this.onDeviceViewerDimensionChanged}
				onClose={this.onDeviceViewerClose}
				afterOpen={this.onDeviceViewerAfterOpen}
			>
				{this.renderForm()}
			</BCDeviceViewer>
		);
	}

	providerWrapper(children: React.ReactElement) {
		if (!this.props.shadow) {
			return children;
		}

		const shadowRootContainer = document.getElementById(`shadowRoot_${this.props.windowId}`);
		const shadowRoot = shadowRootContainer?.shadowRoot;

		return (
			<BCThemeChanger
				environment="WebInterface"
				styleProviderContainer={shadowRoot}
				getPopupContainer={this.form.__getShadowRootContainer}
			>
				<BCLayout style={layoutStyles}>
					<BCContent>{children}</BCContent>
				</BCLayout>
			</BCThemeChanger>
		);
	}

	renderForm() {
		const classes = cx({ mediaScreen: this.props.mediaScreen });
		return this.providerWrapper(
			<div
				className={classes}
				ref={ref => (this.containerElem = ref)}
				style={executionFormContainer}
			>
				{this.form.__render()}
			</div>
		);
	}

	renderInitialLoading() {
		return (
			<BCLoading
				show
				center
				style={{ width: '100%', height: '100%' }}
			/>
		);
	}

	render() {
		if (!this.form?.__windowId) {
			return this.renderInitialLoading();
		}

		switch (this.props.mode) {
			case 'preview':
				return this.renderPreview();
			case 'execution':
			default:
				return <>{this.renderForm()}</>;
		}
	}
}
